import EstimateCard from "@molecules/ObjectCard/ObjectCards/EstimateCard/EstimateCard"

import CardsView from "@organisms/ObjectsView/CardsView/CardsView"

export default function EstimateCardsView() {
    return (
        <CardsView.List<Estimate>>
            {(estimate, displayedAttributes, cardProps) => (
                <EstimateCard estimate={estimate} displayedAttributes={displayedAttributes} {...cardProps} />
            )}
        </CardsView.List>
    )
}
